<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" sm="3" md="3">
        <v-autocomplete
          autocomplete="off"
          name="expenseCategory"
          hide-details
          dense
          outlined
          v-model="record.v_p_m1_s_id"
          :items="expenseAccounts"
          label="Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="3" md="3">
        <v-text-field
          name="expenseAmount"
          dense
          outlined
          label="Amount"
          v-model="record.Amount"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.o_a_c_t_s_id"
          :items="accounts"
          label="Payment Mode"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" sm="3" md="3">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12">
        <v-textarea
          name="expenseDescription"
          outlined
          rows="2"
          label="Description"
          v-model="record.Description"
        ></v-textarea>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn
          v-else
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "AccountsIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    accounts: [],
    expenseAccounts: [],
    employees: [],
    loader: false,
    date: null,
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    sendData() {
      if (this.record.DocDate == undefined || this.record.DocDate == null) {
        this.$refs.snackbar.show("Please select date!", "red");
      } else {
        if (
          this.record.Amount == undefined ||
          this.record.v_p_m1_s_id == undefined ||
          this.record.o_a_c_t_s_id == undefined ||
          this.record.DocDate == null
        ) {
          this.$refs.snackbar.show("Please fill all the fields", "red");
        } else {
          this.$store.commit("btnLoader", true);
          this.$emit("data", this.record);
        }
      }
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    expAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/expenses-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.expenseAccounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.employees = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getAccounts(), this.expAccounts(), this.getUsers()]);
  },
};
</script>